import {
  invoiceControlConfigByCode,
  projectInvoiceStatusConfig,
  quotationRequestConfig,
  FullProjectInvoiceControl,
  LoggedUser,
} from 'entities';

export function defineIfCanChangeType(
  control: FullProjectInvoiceControl,
  user: LoggedUser,
): boolean {
  if (!user.team.isInvoiceTeam || user.type !== 'LEADER') return false;

  const canChange = {
    PACKAGE: [
      !control.package,

      invoiceControlConfigByCode[control.status].canChangePaymentMethod,
    ].every(Boolean),

    STANDARD: [
      control.projectInvoices.every(
        ({ status }) => status === projectInvoiceStatusConfig.canceled.code,
      ),
      // if associated, we know all proj invoices will be canceled
      // if quoted, its inactive
      // if canceled, no brainer
      control.quotationRequests.every(({ status }) =>
        [
          quotationRequestConfig.associated.code,
          quotationRequestConfig.quoted.code,
          quotationRequestConfig.canceled.code,
        ].some((code) => code === status),
      ),

      invoiceControlConfigByCode[control.status].canChangePaymentMethod,
    ].every(Boolean),
  };

  return canChange[control.type as keyof typeof canChange];
}
